import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanupCCB14Drp,
  getCCB14DRP,
} from "../../../../../../api/CCB/DRP/civilJudDRP";
import { DRP_TYPES } from "../../../../../../api/helpers/constants";
import { FORM_ID } from "../../../../../../constants/Forms";
import { ccbActions, logoutActions } from "../../../../../../store/actions";
import {
  fetchCCB,
  postCCB,
  putCCB,
  putCCBStatus,
} from "../../../../../../store/middlewares";
import { loadingStatus } from "../../../../../../store/state";
import NavigationButtons from "../../../../../SharedComponents/NavigationButtons";
import LostDataModal from "../../../../../SharedComponents/LostDataModal";
import CustomCard from "../../common/CustomCard";
import DeleteModal from "../../common/DeleteModal";
import Toast from "../../common/Toast";
import {
  INTRO_REV,
  INTRO_TEXT,
  KEYS,
  RADIO,
  SECTION,
  TOAST_MESSAGE,
} from "../../constants";
import {
  getValues,
  isChecked,
  isEachChecked,
  isSomeChecked,
} from "../../helpers";
import { useClickOutside } from "../../hooks/useClickOutside";
import { headerText } from "../constants";
import { civilJudicialActions, initialState } from "../state";
import { filterByUnchecked } from "../utils";
import "./CivilJudicialForm.scss";
import CustomSubCategoryCard from "./CustomSubCategoryCard";

const CivilJudicialForm = ({
  toggleForm,
  oktaSubId,
  header,
  isLoading: isLoadingProp,
  setIsLoading,
  uncheckedCiv,
  updateCCBForm,
  backFormId,
  nextFormId,
  updateCCB14CompletedInd,
  updateCCB14Step,
  setIsDataRefetch,
}) => {
  const dispatch = useDispatch();

  const toastRef = useRef(null);
  const containerRef = useRef(null);

  const { error, loading, isFirstLoad, data } = useSelector(
    (state) => state.ccb14
  );

  const [isPageChanged, setIsPageChanged] = useState(false);

  const [isShowDRPCleanupModal, setShowDRPCleanupModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [drpCleanupList, setDrpCleanupList] = useState(null);

  const isLoading = loading === loadingStatus.PENDING || isLoadingProp;

  let isError = error || loading === loadingStatus.FAILED;

  const [isRequired, setIsRequired] = useState(false);
  const [isCardOpen, setIsCardOpen] = useState({
    [SECTION.civilJudicialActions]: false,
  });
  const [showBackModal, setShowBackModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const [isEdit, setIsEdit] = useState({
    [SECTION.civilJudicialActions]: false,
  });
  const [isSaved, setIsSaved] = useState({
    [SECTION.civilJudicialActions]: false,
  });

  const valuesA = useMemo(
    () => getValues(data, KEYS.civilJudicialActions),
    [data]
  );

  const isSaveDisabledA = isEachChecked(valuesA);

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    try {
      const initData = async () => {
        const { payload } = await dispatch(fetchCCB(oktaSubId));

        if (payload) {
          const valuesA = getValues(payload, KEYS.civilJudicialActions);
          const a = valuesA.some(isChecked);

          setIsSaved({
            [SECTION.civilJudicialActions]: a,
          });

          setIsEdit({
            [SECTION.civilJudicialActions]: !a,
          });
        } else {
          if (!isSaveDisabledA) {
            setIsCardOpen((prevState) => ({
              ...prevState,
              [SECTION.civilJudicialActions]: true,
            }));
          }
        }
      };

      const a = valuesA.some(isChecked);

      if (loading !== loadingStatus.SUCCEDED) {
        initData();
      } else {
        setIsSaved({
          [SECTION.civilJudicialActions]: a,
        });

        setIsEdit({
          [SECTION.civilJudicialActions]: !a,
        });

        if (!a) {
          setIsCardOpen((prevState) => ({
            ...prevState,
            [SECTION.civilJudicialActions]: true,
          }));
        }

        if (a) {
          setIsCardOpen({ ...initialState });
        }
      }
    } catch (error) {
      console.log({ error });
    }

    return () => {
      const a = valuesA.some(isChecked);

      setIsSaved({
        [SECTION.civilJudicialActions]: a,
      });

      setIsEdit({
        [SECTION.civilJudicialActions]: !a,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageChanged]);

  const [formHasChanged, setFormHasChanged] = useState(false);

  useEffect(() => {
    if (formHasChanged) {
      dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: true }));
    }
  }, [formHasChanged, dispatch]);

  const handleChangeChecked = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    setFormHasChanged(true);

    if (isSaved[SECTION.civilJudicialActions]) {
      updateCCB14Step({ civilJudDisclosureCompleteStep: "1/2" });
      updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: false });
    }

    switch (value) {
      case RADIO.yes:
        newValue = true;
        break;
      case RADIO.no:
        newValue = false;
        break;
      default:
        newValue = null;
        break;
    }

    dispatch(ccbActions.setChecked({ [name]: newValue }));
  };

  const handleOnEditClick = (section) => {
    setIsEdit((prevState) => ({ ...prevState, [section]: true }));
  };

  const updateStatus = async (data) => {
    try {
      await dispatch(
        putCCBStatus({ oktaSubId, data: { civiljudstatus: data } })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const saveHandler = async (section) => {
    if (isSaveDisabledA && section === SECTION.civilJudicialActions) {
      setIsCardOpen((prevState) => ({
        ...prevState,
        [SECTION.civilJudicialActions]: true,
      }));
    }

    setFormHasChanged(false);

    setIsCardOpen((prevState) => ({ ...prevState, [section]: false }));

    if (isFirstLoad) {
      try {
        await dispatch(postCCB({ oktaSubId, data }));
      } catch (err) {
        console.log(err);
        isError = `${err}`;
      }

      setIsSaved((prevState) => ({ ...prevState, [section]: true }));
    } else {
      try {
        await dispatch(putCCB({ oktaSubId, data }));
      } catch (err) {
        console.log(err);
        isError = `${err}`;
      }

      setIsSaved((prevState) => ({ ...prevState, [section]: true }));
    }

    const isNo = (currentValue) => currentValue === false;
    const isYes = (currentValue) => currentValue === true;

    const isNoValues = valuesA.every(isNo);
    const isYesValues = valuesA.some(isYes);

    if (isNoValues) {
      updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: true });
      updateStatus(null);
    } else if (isYesValues) {
      updateCCB14Step({ civilJudDisclosureCompleteStep: "1/2" });
      updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: false });
    }
    setIsEdit((prevState) => ({ ...prevState, [section]: false }));
    setShowToast(true);

    setIsEdit((prevState) => ({ ...prevState, [section]: false }));
    setIsCardOpen({
      [SECTION.civilJudicialActions]: false,
    });
    setShowToast(true);
  };

  const handleOnSaveClick = async (section) => {
    handleCloseToast();
    setSelectedSection(section);

    const { drpvalues } = await getCCB14DRP({
      oktaSubId,
      drpTypeId: DRP_TYPES.CivilJudicial,
    });

    const drpList = filterByUnchecked(section, uncheckedCiv, drpvalues);

    if (drpList.length) {
      setDrpCleanupList(drpList);
      setShowDRPCleanupModal(true);
    } else {
      saveHandler(section);
    }

    window.scrollTo(0, 0);
  };

  const handleCloseToast = () => setShowToast(false);

  const closeCleanupModalHandler = async () => {
    setShowDRPCleanupModal(false);
  };

  const onCleanupModalHandler = async () => {
    if (selectedSection === null) {
      return;
    }

    setIsLoading(true);

    await cleanupCCB14Drp({
      oktaSubId,
      drpTypeId: DRP_TYPES.CivilJudicial,
      data: {
        data: {
          civ: uncheckedCiv,
        },
      },
    });

    setIsLoading(false);

    await saveHandler(selectedSection);

    setIsDataRefetch(true);

    setShowDRPCleanupModal(false);
  };

  useEffect(() => {
    let handler = (e) => {
      if (!toastRef?.current?.contains(e.target)) {
        handleCloseToast();
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleCloseBackModal = () => setShowBackModal(false);

  const cleanup = (isFetch = false) => {
    dispatch(ccbActions.setChecked({ ...initialState }));
    setIsRequired(false);
    handleCloseToast();
    setFormHasChanged(false);
    setIsCardOpen({
      ...isCardOpen,
      [SECTION.civilJudicialActions]: false,
    });
    setIsEdit({
      [SECTION.civilJudicialActions]: false,
    });

    if (!isFetch) {
      setIsPageChanged((prev) => !prev);
    }
  };

  const handleShowBackModal = () => {
    if (
      ((isSomeChecked(valuesA) && isEdit[SECTION.civilJudicialActions]) ||
        (isSomeChecked(valuesA) && !isSaved[SECTION.civilJudicialActions])) &&
      formHasChanged
    ) {
      setShowBackModal(true);
    } else {
      dispatch(ccbActions.setIsBack(true));
      toggleForm(backFormId);
      setIsPageChanged((prev) => !prev);
    }
  };

  const handleBackClick = async () => {
    cleanup();
    toggleForm(backFormId);

    if (isSaved[SECTION.civilJudicialActions]) {
      updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: true });
    }

    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));
    dispatch(ccbActions.setIsBack(true));
    handleCloseBackModal();
  };

  const handleNext = async () => {
    dispatch(ccbActions.setIsBack(false));
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));
    cleanup(true);

    const isYes = (currentValue) => currentValue === true;
    let isYesValues = valuesA.some(isYes);

    if (loading === loadingStatus.IDLE || loading === loadingStatus.SUCCEDED) {
      const { payload } = await dispatch(fetchCCB(oktaSubId));

      isYesValues = getValues(payload, KEYS.civilJudicialActions).some(isYes);
    }

    if (isYesValues) {
      updateCCBForm(nextFormId);
    } else {
      updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: true });
      updateStatus(null);
      toggleForm(FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE);
    }
  };

  const renderSubcategory = (category, section) => {
    const disabledSave =
      (isSaved[SECTION.civilJudicialActions] &&
        !isEdit[SECTION.civilJudicialActions] &&
        section === SECTION.civilJudicialActions) ||
      (!isSaveDisabledA && section === SECTION.civilJudicialActions);

    return (
      <CustomSubCategoryCard
        data={data}
        category={category}
        handleOnEditClick={handleOnEditClick}
        handleChangeChecked={handleChangeChecked}
        handleOnSaveClick={handleOnSaveClick}
        section={section}
        isSaved={isSaved}
        isLoading={isLoading}
        isRequired={isRequired}
        disabledSave={disabledSave}
        ref={containerRef}
      />
    );
  };

  useClickOutside(toastRef, containerRef, showToast, handleCloseToast);

  return (
    <div className="civil-judicial-form-wrapper" ref={containerRef}>
      <Toast
        showToast={showToast}
        closeToast={handleCloseToast}
        text={TOAST_MESSAGE}
        ref={toastRef}
      />

      <div className="row">
        <div className="col-md-12">
          <div className="eyebrow">
            <strong id={`eyebrow-${header}`}>
              Character, Credit, and Bonding
            </strong>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <h1 id={`header-${header}`}>{header}</h1>
          <h2 id={`ccb_intro_rev-${header}`} style={{ color: "black" }}>
            {INTRO_REV}
          </h2>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <p id={`intro-text-${header}`}>{INTRO_TEXT}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <CustomCard
            isOpen={isCardOpen[SECTION.civilJudicialActions]}
            setIsOpen={setIsCardOpen}
            headerText={headerText.CIV_JUD_ACT}
            isCompleted={isSaved[SECTION.civilJudicialActions]}
            index={SECTION.civilJudicialActions}
          >
            {renderSubcategory(
              civilJudicialActions(
                isSaved[SECTION.civilJudicialActions] &&
                  !isEdit[SECTION.civilJudicialActions]
              ),
              SECTION.civilJudicialActions
            )}
          </CustomCard>
        </div>
      </div>
      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        nxtbtnid={"civilJudDisNext"}
        bckbtnid={"civilJudDisBack"}
        isLoading={isLoading}
        isDisabled={
          !isSaved[SECTION.civilJudicialActions] || !!isError || !!isLoading
        }
      />

      {isShowDRPCleanupModal && (
        <DeleteModal
          isOpen={isShowDRPCleanupModal}
          showSpinner={false}
          isDRP
          type={headerText.HEADER}
          list={drpCleanupList}
          description="You had previously provided a DRP(s) associated with this
          question. Changing your response will delete the following
          DRP(s). Are you sure you want to proceed?"
          message="Are You Sure You Want To Proceed?"
          closeClick={closeCleanupModalHandler}
          deleteClick={onCleanupModalHandler}
        />
      )}
      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default CivilJudicialForm;
